import 'reflect-metadata';
import React from "react";
import ReactDOM from "react-dom";
import { Login } from '../components/Login/Login';

ReactDOM.render(
  <Login />,
  document.getElementById("app-container")
);